exports.install = function (Vue, options) {
  Vue.prototype.formatDate = function (updateTime) { //格式化时间
    if (updateTime) {
      var date = new Date(updateTime);
      var Year = date.getFullYear(); //ie火狐下都可以 
      var Month = date.getMonth() + 1
      var Day = date.getDate()
      Month = Month < 10 ? '0' + Month : Month
      Day = Day < 10 ? '0' + Day : Day;
      var formatDates = Year + '年' + Month + '月' + Day + '日'
      return formatDates
    }
  };
  Vue.prototype.localImgUrl = function (url) { //本地服务器图片
    if(url){
      var localUrl = "http://39.107.228.160" + url;
      return localUrl;
    }
  };
};



// WEBPACK FOOTER //
// ./src/formatDate/index.js